import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { BackgroundColor, TextColor } =
  themeColorSectionKeys.TopNav.EnvironmentLabel

const EnvironmentLabelStyleParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(EnvironmentLabelStyleParts)

export const EnvironmentLabelStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: BackgroundColor,
      borderRadius: '6px',
      padding: '8px',
      userSelect: 'none',
    },
    text: {
      color: TextColor,
      textStyle: textStyleKeys.Body3,
    },
  },
})

export const useEnvironmentLabelStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof EnvironmentLabelStyleParts>(
    getName({ EnvironmentLabelStyle }),
    props,
  )
}
